import Decimal from 'decimal.js';
const typeList = [
  {
    label: '财产案件',
    value: 1
  },
  {
    label: '离婚案件',
    value: 2
  },
  {
    label: '人格权案件',
    value: 3
  },
  {
    label: '其他非财产案件',
    value: 4
  },
  {
    label: '知识产权民事案件',
    value: 5
  },
  {
    label: '劳动争议案件',
    value: 6
  },
  {
    label: '商标、专利、海事行政案件',
    value: 7
  },
  {
    label: '其他行政案件',
    value: 8
  },
  {
    label: '管辖权异议不成立案件',
    value: 9
  }
]

const priceReturn = (price, price2 = 0) => {
  console.log(111, price);
  console.log(222, Number(price.toFixed(2)));
  return {
    min: Number(price.toFixed(2)),
    max: Number(price2.toFixed(2))
  }
}
function calculateFee(amount, rules) {
  for (let i = 0; i < rules.length; i++) {
    const { min = 0, max = Infinity, rate = 0, base = 0, fixed = null } = rules[i];
    if (amount > min && amount <= max) {
      return fixed !== null ? fixed : amount.times(rate).plus(base);
    }
  }
  return 0;
}
const type1 = (price) => {
  const ranges = [
    { max: 10000, fixed: 50 },
    { min: 10000, max: 100000, rate: 0.025, base: -200 },
    { min: 100000, max: 200000, rate: 0.02, base: 300 },
    { min: 200000, max: 500000, rate: 0.015, base: 1300 },
    { min: 500000, max: 1000000, rate: 0.01, base: 3800 },
    { min: 1000000, max: 2000000, rate: 0.009, base: 4800 },
    { min: 2000000, max: 5000000, rate: 0.008, base: 6800 },
    { min: 5000000, max: 10000000, rate: 0.007, base: 11800 },
    { min: 10000000, max: 20000000, rate: 0.006, base: 21800 },
    { min: 20000000, max: Infinity, rate: 0.005, base: 41800 },
  ];
  return priceReturn(calculateFee(new Decimal(price), ranges))
}
const type2 = (price, involvingProperty) => {

  if (involvingProperty === 'TRUE' && price > 200000) {
    const exceedingTheAmount = new Decimal(price).minus(200000);
    const fee = exceedingTheAmount.times(0.005);
    return priceReturn(fee.plus(50), fee.plus(300))
  } else {
    return priceReturn(50, 300)
  }
}
const type3 = (price) => {
  if (price > 50000) {
    const ranges = [
      { min: 50000, max: 100000, rate: 0.01, base: -500 },
      { min: 100000, max: Infinity, rate: 0.005, base: 0 },
    ];
    const fee = calculateFee(Decimal(price), ranges);
    return priceReturn(fee.plus(100), fee.plus(500))
  } else {

    return priceReturn(100, 500)
  }
}
const type4 = (price) => {
  return priceReturn(50, 100)
}
const type5 = (price, involvingProperty) => {
  if (involvingProperty === 'TRUE') {
    const ranges = [
      { max: 10000, fixed: 50 },
      { min: 10000, max: 100000, rate: 0.025, base: -200 },
      { min: 100000, max: 200000, rate: 0.02, base: 300 },
      { min: 200000, max: 500000, rate: 0.015, base: 1300 },
      { min: 500000, max: 1000000, rate: 0.01, base: 3800 },
      { min: 1000000, max: 2000000, rate: 0.009, base: 4800 },
      { min: 2000000, max: 5000000, rate: 0.008, base: 6800 },
      { min: 5000000, max: 10000000, rate: 0.007, base: 11800 },
      { min: 10000000, max: 20000000, rate: 0.006, base: 21800 },
      { min: 20000000, max: Infinity, rate: 0.005, base: 41800 },
    ];
    return priceReturn(calculateFee(new Decimal(price), ranges))
  } else {
    return priceReturn(500, 1000)
  }

}
const type6 = (price) => {
  if (price > 200000) {
    const exceedingTheAmount = new Decimal(price).minus(200000);
    const fee = exceedingTheAmount.times(0.005);
    return priceReturn(fee.plus(10))
  } else {
    return priceReturn(10)
  }
}
const type7 = (price) => {
  return priceReturn(100)
}
const type8 = (price) => {
  return priceReturn(50)
}
const type9 = (price) => {
  return priceReturn(50, 100)
}


const calculatorFn = ({ type, price, involvingProperty }) => {
  if (type === 1) {
    return type1(price)
  }
  if (type === 2) {
    return type2(price, involvingProperty)
  }
  if (type === 3) {
    return type3(price)
  }
  if (type === 4) {
    return type4(price)
  }
  if (type === 5) {
    return type5(price, involvingProperty)
  }
  if (type === 6) {
    return type6(price)
  }
  if (type === 7) {
    return type7(price)
  }
  if (type === 8) {
    return type8(price)
  }
  if (type === 9) {
    return type9(price)
  }

}


export {
  typeList,
  calculatorFn
}